export interface ArtShape {
  /** Height / width. */
  ratio: number
  /** Share of the image that is not transparent, 0–1. */
  coverage: number
}

/**
 * A set image's shape, cached per URL. Coverage is read off a 64px copy; the
 * art comes from the CDN, which sends CORS headers (the print bake relies on
 * the same). If the pixels cannot be read, the set is drawn at base size.
 */
const shapes = new Map<string, Promise<ArtShape>>()
export const artShape = (url: string): Promise<ArtShape> => {
  if (!shapes.has(url)) {
    shapes.set(
      url,
      new Promise((resolve) => {
        const img = new Image()
        img.crossOrigin = 'anonymous'
        img.onload = (): void => {
          const ratio = img.naturalWidth ? img.naturalHeight / img.naturalWidth : 1
          let coverage = 0.45
          try {
            const canvas = document.createElement('canvas')
            canvas.width = 64
            canvas.height = Math.max(1, Math.round(64 * ratio))
            const ctx = canvas.getContext('2d')
            if (ctx) {
              ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
              const { data } = ctx.getImageData(0, 0, canvas.width, canvas.height)
              let ink = 0
              for (let k = 3; k < data.length; k += 4) if (data[k] > 24) ink++
              coverage = ink / (canvas.width * canvas.height)
            }
          } catch {
            // Tainted canvas: keep the base size.
          }
          resolve({ ratio, coverage })
        }
        img.onerror = (): void => resolve({ ratio: 1, coverage: 0.45 })
        img.src = url
      })
    )
  }
  return shapes.get(url) as Promise<ArtShape>
}
